/**
 * Product Media Pagination for Counter Layout
 * Makes the counter navigation functional
 */

class ProductMediaPagination extends HTMLElement {
  constructor() {
    super();
    this.mediaGallery = document.querySelector('media-gallery');
    this.sliderComponent = this.mediaGallery?.querySelector('slider-component');
    this.slider = this.sliderComponent?.querySelector('.product__media-list');
    this.slides = this.slider?.querySelectorAll('.product__media-item');
    
    if (!this.slider || !this.slides || this.slides.length === 0) return;
    
    this.currentSlide = 0;
    this.totalSlides = this.slides.length;
    
    this.prevButton = this.querySelector('.slider-button--prev');
    this.nextButton = this.querySelector('.slider-button--next');
    this.counterCurrent = this.querySelector('.slider-counter--current');
    this.counterTotal = this.querySelector('.slider-counter--total');
    
    this.init();
  }
  
  init() {
    // Set initial counter
    if (this.counterTotal) {
      this.counterTotal.textContent = this.totalSlides;
    }
    
    // Add event listeners to counter arrows
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => this.navigateToPrevSlide());
    }
    
    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => this.navigateToNextSlide());
    }
    
    // Add event listeners to overlay arrows (if they exist)
    const overlayPrevButton = this.sliderComponent?.querySelector('.slider-button--prev');
    const overlayNextButton = this.sliderComponent?.querySelector('.slider-button--next');
    
    if (overlayPrevButton) {
      overlayPrevButton.addEventListener('click', () => this.navigateToPrevSlide());
    }
    
    if (overlayNextButton) {
      overlayNextButton.addEventListener('click', () => this.navigateToNextSlide());
    }
    
    // Update counter when thumbnails are clicked
    if (this.mediaGallery) {
      this.mediaGallery.addEventListener('change', () => this.updateCounterFromGallery());
    }
    
    // Initial update
    this.updateCounter();
    this.updateButtons();
    this.updateOverlayButtons();
  }
  
  navigateToPrevSlide() {
    if (this.currentSlide > 0) {
      this.currentSlide--;
      this.changeSlide();
    }
  }
  
  navigateToNextSlide() {
    if (this.currentSlide < this.totalSlides - 1) {
      this.currentSlide++;
      this.changeSlide();
    }
  }
  
  changeSlide() {
    // Remove is-active from all slides
    this.slides.forEach(slide => slide.classList.remove('is-active'));
    
    // Add is-active to current slide
    const currentSlideElement = this.slides[this.currentSlide];
    if (currentSlideElement) {
      currentSlideElement.classList.add('is-active');
      
      // Note: No scrollIntoView - user stays at current scroll position
    }
    
    // Update counter and buttons
    this.updateCounter();
    this.updateButtons();
    
    // Trigger change event for thumbnails sync
    this.updateThumbnails();
  }
  
  updateCounter() {
    if (this.counterCurrent) {
      this.counterCurrent.textContent = this.currentSlide + 1;
    }
  }
  
  updateButtons() {
    // Disable prev button on first slide
    if (this.prevButton) {
      this.prevButton.disabled = this.currentSlide === 0;
    }
    
    // Disable next button on last slide
    if (this.nextButton) {
      this.nextButton.disabled = this.currentSlide === this.totalSlides - 1;
    }
    
    // Also update overlay buttons
    this.updateOverlayButtons();
  }
  
  updateOverlayButtons() {
    // Update overlay arrows (the ones on top of media)
    const overlayPrevButton = this.sliderComponent?.querySelector('.slider-button--prev');
    const overlayNextButton = this.sliderComponent?.querySelector('.slider-button--next');
    
    if (overlayPrevButton) {
      overlayPrevButton.disabled = this.currentSlide === 0;
    }
    
    if (overlayNextButton) {
      overlayNextButton.disabled = this.currentSlide === this.totalSlides - 1;
    }
  }
  
  updateThumbnails() {
    // Find and click the corresponding thumbnail
    const thumbnailList = document.querySelector('.thumbnail-list');
    if (!thumbnailList) return;
    
    const thumbnails = thumbnailList.querySelectorAll('.thumbnail');
    if (thumbnails[this.currentSlide]) {
      thumbnails[this.currentSlide].click();
    }
  }
  
  updateCounterFromGallery() {
    // Update counter when gallery changes (e.g., from thumbnail click)
    const activeSlide = Array.from(this.slides).findIndex(slide => 
      slide.classList.contains('is-active')
    );
    
    if (activeSlide !== -1 && activeSlide !== this.currentSlide) {
      this.currentSlide = activeSlide;
      this.updateCounter();
      this.updateButtons();
    }
  }
}

customElements.define('product-media-pagination', ProductMediaPagination);